import React from 'react'

const TechBaseFooter = props => {
  return(
    <div className="text-center py-2 techbase-footer" style={ props.item?.style || {} } >{ `© Copyright 2025 ${ props.data.ClientReducer.clientInfo.name } - All rights reserved.` }</div>
  )
}

export default TechBaseFooter